export default {"src":"/_next/static/media/close.cd470e82.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};